var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.data.length
    ? _c(
        "v-col",
        {
          staticClass: "text-center caption error--text",
          attrs: {
            cols: "12"
          }
        },
        [
          !_vm.single
            ? _c(
                "div",
                _vm._l(_vm.data, function(error, index) {
                  return _c(
                    "div",
                    {
                      key: index
                    },
                    [_vm._v(" " + _vm._s(error) + " ")]
                  )
                }),
                0
              )
            : _c("div", [_vm._v(" " + _vm._s(_vm.data) + " ")])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }